export default __webpack_public_path__ + "static/media/avatar_placeholder.4233244c.jpg";